module.exports = __webpack_public_path__ + "images/d7df4e13.jpg";